import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import LocaleCode from 'locale-code';
import { without, reduce, indexOf, find, findIndex, delay } from 'lodash';
import { withRouter } from 'react-router-dom';
import ReactResizeDetector from 'react-resize-detector';
import ProgressBar from '../../../../components/progress-bar';
import PathDisplay from '../../../../components/search-path/path';
import SearchField from '../../../../components/search-field';
import MappingToggleCellRenderer from '../FilterPage/MappingToggle';
import ExcludeToggleCellRenderer from '../FilterPage/ExcludeToggle';
import LabelCellRenderer from '../FilterPage/LabelCellRenderer';

import { transalteLanguageCode } from '../../../../util/helpers';

import { getViewableDimensions } from '../../../App/AppReducer';

import {
  fetchFeedbackLanguageSettings,
  updateFeedbackLanguageSettings,
} from '../../SetupActions';

class FeedbackLanguageDetailPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loaded: false,
      settings: null,
      updatingColId: null,
      updatingRowId: null,
      navBarHeight: 0,
      options: [],
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.onResizeNavBar = this.onResizeNavBar.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
    this.getMappingCellRendererSelector = this.getMappingCellRendererSelector.bind(this);
    this.getColumnDefs = this.getColumnDefs.bind(this);
    this.valueMappingGetter = this.valueMappingGetter.bind(this);
    this.excludedValueMappingGetter = this.excludedValueMappingGetter.bind(this);
    this.getExcludeCellRendererSelector = this.getExcludeCellRendererSelector.bind(this);
    this.excludeValue = this.excludeValue.bind(this);
    this.toggleValue = this.toggleValue.bind(this);
  }
  
  componentDidMount() {
    this.fetchData();
  }

  onResizeNavBar(width, navBarHeight) {
    this.setState({ navBarHeight });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  handleSearch(query) {
    if (this.gridApi) {
      this.setState({ query }, () => {
        this.gridApi.setQuickFilter(query);
      });
    }
  }

  refreshCells() {
    if (this.gridApi) {
      const params = { force: true };
      this.gridApi.refreshCells(params);
    }
  }

  flashRow(rowId) {
    if (this.gridApi) {
      const node = this.gridApi.getRowNode(rowId);
      if (node) {
        this.gridApi.flashCells({ rowNodes: [node] });
      }
    }
  }


  submitValues(mapping, values) {
    const { settings } = this.state;
    
    return new Promise((resolve, reject) => {
      const params = {
        mappings: [...settings.mappings],
      };
      const idx = findIndex(params.mappings, { _id: mapping._id });
      if (idx >= 0) {
        params.mappings[idx] = {
          ...mapping,
          values: [...values],
        };
        this.props.dispatch(updateFeedbackLanguageSettings(settings._id, params))
          .then(
            (results) => {
              this.setState({ settings: results }, () => {
                resolve();
              });
            },
            (e) => {
              reject(e);
            },
          );
      } else {
        reject();
      }
    });
  }

  toggleValue(mapping, value) {
    if (this.state.updatingRowId || this.state.updatingColId) {
      return;
    }
    const values = mapping.values || [];
    const active = indexOf(values, value) >= 0;
    const newValues = active ? without(values, value) : [...values].concat([value]);

    this.setState({ updatingRowId: value, updatingColId: mapping._id }, () => {
      this.submitValues(mapping, newValues, false)
        .then(
          () => {
            this.setState({ updatingRowId: null, updatingColId: null }, () => {
              this.flashRow(value);
              delay(() => {
                if (this.gridApi) {
                  this.gridApi.refreshCells({ 
                    force: true, 
                    // columns: [`mappings.${program.client_id}.${program.program_id}`],
                  });
                }
              });

            });
          },
          () => {
            this.setState({ updatingRowId: null, updatingColId: null }, () => {
              this.refreshCells();
            });
          },
        );
    });
  }


  excludeValue(value) {
    if (this.state.updatingRowId || this.state.updatingColId) {
      return;
    }
    const { settings } = this.state;
    this.setState({ updatingRowId: value, updatingColId: null }, () => {
      const params = {
        mappings: reduce(settings.mappings, (items, m) => {
          items.push({
            ...m,
            values: without(m.values, value),
          });
          return items;
        }, []),
      };
      this.props.dispatch(updateFeedbackLanguageSettings(settings._id, params))
        .then(
          (results) => {
            this.setState({ settings: results, updatingRowId: null }, () => {
              delay(() => {
                if (this.gridApi) {
                  this.gridApi.refreshCells({ 
                    force: true, 
                    // columns: [`mappings.${program.client_id}.${program.program_id}`],
                  });
                }
              });
            });
          },
          () => {
          },
        );
    });
  }

  showModal() {
    this.setState({ showModal: true });
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  valueMappingGetter(params) {
    if (!params.data) {
      return null;
    }
    const { data, colDef: { colId } } = params;
    const { settings } = this.state;
    const mapping = find(settings.mappings, { _id: colId });
    if (!mapping) {
      return false;
    }
    const values = mapping.values || [];
    return indexOf(values, data.value) >= 0;
  }

  excludedValueMappingGetter(params) {
    const { data } = params;
    if (!data) {
      return null;
    }
    const { settings } = this.state;
    const mappings = settings.mappings || [];
    const { value } = data;
    const v = reduce(mappings, (itm, mapping) => {
      const indx = indexOf(mapping.values, value);
      if (indx >= 0) {
        return true;
      }
      return itm || false;
    }, false);
    return !v;
  }

  fetchData() {
    this.setState({ loading: true, loaded: false }, () => {
      this.props.dispatch(fetchFeedbackLanguageSettings(this.props.match.params.id))
        .then(
          (settings) => {
            this.setState({ settings, options: [...settings.options], loaded: true, loading: false });
          },
          (e) => {
             const el = (
              <div>{e?.data?.message || 'Error'}</div>
            );
            this.context.addNotification(el, { type: 'error', autoClose: 10000 });
          },
        );
    });
  }

  handleSuccess(settings) {
    this.setState({ settings });
  }

  getExcludeCellRendererSelector(params) {
    if (!params) {
      return null;
    }
    return {
      component: ExcludeToggleCellRenderer,
      params: {
        onToggleValue: this.excludeValue,
      },
    };
  }

  getMappingCellRendererSelector(params) {
    if (!params) {
      return null;
    }
    return {
      component: MappingToggleCellRenderer,
      params: {
        onToggleValue: this.toggleValue,
      },
    };
  }


  getColumnDefs() {
    const { settings } = this.state;
    
    const totalMappings = settings && settings.mappings ? settings.mappings.length : 0;
    const renderExcludeColumn = totalMappings > 1;

    const columnDefs = [
      {
        headerName: 'Value',
        field: 'label',
        pinned: 'left',
        colId: 'LABEL',
        suppressMenu: true,
        suppressMovable: true,
        cellRenderer: LabelCellRenderer,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
      },
      ...(settings.mappings.map(m => ({
        headerName: LocaleCode.getLanguageNativeName(transalteLanguageCode(m.code)),
        colId: m._id,
        suppressMovable: true,
        suppressMenu: true,
        // field: 'value', // TODO: get value! is checked? so that it can be sorted
        minWidth: 100,
        valueGetter: this.valueMappingGetter,
        cellRendererSelector: this.getMappingCellRendererSelector,
        cellRendererParams: {
          column: m,
        },
      }))),
      ...(renderExcludeColumn ? [
        {
          headerName: 'Exclude',
          colId: 'EXCLUDE',
          // field: 'excluded', // invert of this!
          suppressMenu: true,
          suppressMovable: true,
          suppressColumnsToolPanel: true,
          suppressFiltersToolPanel: true,
          minWidth: 100,
          valueGetter: this.excludedValueMappingGetter,
          cellRendererSelector: this.getExcludeCellRendererSelector,
          cellRendererParams: {
          },
          pinned: 'right',
        },
      ] : []),
    ];
    return columnDefs;
  }

  renderSearchPath(setting) {
    if (!setting || !setting.search_paths) {
      return null;
    }
    const isAccount = this.props.match.params.source === 'accounts';
    return (
      <PathDisplay startingNode={isAccount ? 'Account' : 'Opportunity'} paths={setting.search_paths} />
    );
  }

  renderTable() {
    const { settings, updatingRowId, updatingColId, options, navBarHeight } = this.state;
    const { viewableDimensions } = this.props;


    const viewableHeight = viewableDimensions.height - navBarHeight;

    const stl = {
      width: '100%',
      height: viewableHeight,
    };

    return (
      <div>
        <nav className="navbar navbar-default navbar-controls">
          <form className="navbar-form navbar-left">
            <SearchField onSearch={this.handleSearch} />
          </form>
          <ReactResizeDetector handleHeight onResize={this.onResizeNavBar} />
        </nav>

        <div className="ag-theme-alpine" style={stl}>
          <AgGridReact
            reactNext
            enableColResize
            enableSorting
            animateRows
            columnDefs={this.getColumnDefs()}
            getRowId={params => params.data?.value}
            onGridReady={this.onGridReady}
            suppressColumnVirtualisation
            context={{ 
              mappings: settings.mappings,
              updatingRowId,
              updatingColId,
            }}
            rowData={options}
          />
        </div>
      </div>
    );
  }

  render() {
    const { loading, loaded, settings } = this.state;
    const isLoading = loading || !loaded;
    if (isLoading) {
      return (
        <div>
          <ProgressBar />
        </div>
      );
    }
   
    return (
      <div>
        <div className="well">
          Language mapping for field {this.renderSearchPath(settings)}
        </div>
        {this.renderTable()}
      </div>
    );
  }
}

/** Retrieve data from store as props */
function mapStateToProps(state) {
  return {
    viewableDimensions: getViewableDimensions(state),
  };
}

FeedbackLanguageDetailPage.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
      source: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  viewableDimensions: PropTypes.shape({
    height: PropTypes.number,
  }).isRequired,
};
FeedbackLanguageDetailPage.defaultProps = {
};
FeedbackLanguageDetailPage.contextTypes = {
  router: PropTypes.object,
  addNotification: PropTypes.func.isRequired,
};

export default withRouter(connect(mapStateToProps)(FeedbackLanguageDetailPage));
